import React from "react"

export function MenuItemDescription({ children }: { children: React.ReactNode }) {
  return <span className="text-sm leading-6 font-normal" data-slot="menu-item-description">{children}</span>
}

MenuItemDescription.displayName = "Menu.ItemDescription"
